export default function AttachFindingFolderController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  amDataService,
  docDataService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Folder Added';
  vm.isExpanded = false;
  vm.loaded = false;
  vm.loading = false;

  // Attach Event Handlers
  vm.handleExpandFolder = _handleExpandFolder;
  vm.handleAttachFolder = _handleAttachFolder;

  function _handleExpandFolder() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      _refreshFolder();
    }
  }

  function _refreshFolder() {
    vm.loaded = false;
    loaderService.showViewLoader = true;

    docDataService.getChildItemList(vm.serviceId, vm.folder.documentId).then((response) => {
      vm.folder.childDocuments = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 0 });
      vm.folder.childFolders = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 1 });

      $q.all([
        _updateChildDocuments(),
        _updateChildFolders(),
      ]).then(() => {
        vm.loaded = true;
        loaderService.showViewLoader = false;
      });
    });
  }

  function _updateChildDocuments() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childDocuments.length > 0) {
      amDataService.getFindingDocumentsByFolder(vm.folder.documentId).then((response) => {
        const assignedDocs = response.data.result;
        if (assignedDocs.length > 0) {
          assignedDocs.forEach((assignedDoc) => {
            vm.folder.childDocuments.forEach((childDoc) => {
              if (childDoc.documentId === assignedDoc.documentId && assignedDoc.findingId === vm.findingId) {
                childDoc.findingDocumentId = assignedDoc.findingDocumentId;
                childDoc.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _updateChildFolders() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childFolders.length > 0) {
      amDataService.getFindingFoldersByFolder(vm.folder.documentId).then((response) => {
        const assignedFolders = response.data.result;
        if (assignedFolders.length > 0) {
          assignedFolders.forEach((assignedFolder) => {
            vm.folder.childFolders.forEach((childFolder) => {
              if (childFolder.documentId === assignedFolder.folderId && assignedFolder.findingId === vm.findingId) {
                childFolder.findingFolderId = assignedFolder.findingFolderId;
                childFolder.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _handleAttachFolder() {
    const dfdSave = $q.defer();

    if (vm.folder.attached) {
      amDataService.attachFindingFolder(vm.findingId, vm.folder.documentId).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while attaching the Folder.');
          dfdSave.reject();
        } else {
          alerts.success(`Folder ${vm.folder.name} has been attached successfully.`);
          vm.folder.findingFolderId = response.data.findingFolderId;
          $rootScope.$broadcast('refreshAMFindingFolders', { findingId: vm.findingId });
          $rootScope.$broadcast('refreshAMFindingDocuments', { findingId: vm.findingId });
          dfdSave.resolve();
        }
      });
    } else {
      amDataService.detachFindingFolder(vm.folder.findingFolderId).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while detaching the Folder.');
          dfdSave.reject();
        } else {
          alerts.success(`Folder ${vm.folder.name} has been detached successfully.`);
          vm.folder.findingFolderId = null;
          $rootScope.$broadcast('refreshAMFindingFolders', { findingId: vm.findingId });
          $rootScope.$broadcast('refreshAMFindingDocuments', { findingId: vm.findingId });
          dfdSave.resolve();
        }
      });
    }
  }
}

AttachFindingFolderController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'amDataService',
  'docDataService'
];
